var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02859 23.2855L25.1469 13.4022C26.7199 12.4941 27.2609 10.4749 26.3528 8.90195L22.5093 2.24481L-0.315188 15.4225L3.52831 22.0797C4.43648 23.6526 6.4556 24.1937 8.02859 23.2855ZM2.68499 16.2264L5.53805 14.5792L7.18527 17.4323L9.08731 16.3341L7.44009 13.4811L9.34213 12.3829L10.9893 15.236L12.8914 14.1378L11.2442 11.2848L13.1462 10.1866L14.7934 13.0397L16.6955 11.9416L15.0483 9.08849L16.9503 7.99035L18.5975 10.8434L20.4995 9.74526L18.8523 6.8922L21.7054 5.24499L24.4507 10.0001C24.7538 10.5251 24.5738 11.1971 24.0488 11.5002L6.93044 21.3835C6.40548 21.6866 5.73344 21.5065 5.43035 20.9815L2.68499 16.2264Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.5743a04ab58624183fe7066909e2e100.svg";
export { ForwardRef as ReactComponent };